import { Stage } from '../types/content'

export const stages: Stage[] = [
  {
    id: 'early',
    name: 'Early signals',
    ages: 'Roughly 35–44',
    physiology: 'Progesterone starts falling first. Estrogen is still high, but erratic.',
    detail:
      'Cycles are still regular enough that nothing looks wrong on paper. What changes is how you feel in the two weeks before a period: worse sleep, a shorter fuse, breast tenderness, anxiety that arrives without a reason. This is the stage women are most often told they are too young for.',
    careLooksLike:
      'Naming it. Cycle-timed progesterone, sleep and anxiety support, and a clinician who will write it in your chart instead of dismissing it.',
  },
  {
    id: 'peri',
    name: 'Perimenopause',
    ages: 'Roughly 45–51',
    physiology: 'Estrogen swings violently — higher than it has ever been, then crashing.',
    detail:
      'Periods change length, heaviness, or start skipping. Hot flushes and night sweats arrive. Brain fog gets frightening enough that women in this stage routinely search for early dementia. It is not dementia. It is estrogen withdrawal affecting the brain, and it is temporary.',
    careLooksLike:
      'Transdermal estradiol with progesterone, titrated to symptoms rather than to a lab number. Non-hormonal options where hormones are not right for you.',
  },
  {
    id: 'menopause',
    name: 'Menopause',
    ages: 'Average age 51',
    physiology: 'One single day: twelve consecutive months without a period.',
    detail:
      'Menopause itself is a date, not a phase — everything before it is perimenopause and everything after is post-menopause. Most people use the word for the whole decade, which is part of why the conversation is so confused.',
    careLooksLike:
      'Confirming where you are, reviewing whether hormone therapy still fits, and looking ahead at bone and heart risk.',
  },
  {
    id: 'post',
    name: 'Post-menopause',
    ages: '51 onward',
    physiology: 'Estrogen settles at a low, stable level and stays there.',
    detail:
      'Hot flushes often fade — though for around a third of women they last a decade or more. What does not fade on its own is vaginal and urinary tissue change, bone loss, and shifting cardiovascular risk. These are the quiet ones nobody warns you about.',
    careLooksLike:
      'Local estrogen for tissue health, bone density monitoring, lipids and blood pressure, and a real conversation about staying on hormone therapy long term.',
  },
]

export function getStage(id: string): Stage | undefined {
  return stages.find((stage) => stage.id === id)
}
